import React, { useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import ScrollableContent from '@wix/da-ds/pkg/ScrollableContent';
import TextInput from '@wix/da-ds/pkg/formControls/dsPresets/TextInput';
import DSModal from '@wix/da-ds/pkg/modals/dsPresets/Modal';
import LoadingIndicator from '@wix/da-ds/pkg/LoadingIndicator';
import { fetchGifs } from '../../../redux/actions/extension-gif';
import { gifItems, gifPage, gifFetching, gifHasMore, gifApiError } from '../../../redux/selectors/extension-gif';
import PoweredByGiphy from './PoweredByGiphy';
import s from './GiphyPopup.scss';
const FETCH_TRIGGER_DISTANCE = 80;
const GiphyModal = ({ onSelect, onClose })=>{
    const { t } = useTranslation('editor');
    const [searchTag, setSearchTag] = useState('');
    const onChange = useCallback((e)=>{
        setSearchTag(e.target.value);
    }, [
        setSearchTag
    ]);
    const dispatch = useDispatch();
    const gifs = useSelector(gifItems);
    const page = useSelector(gifPage);
    const fetching = useSelector(gifFetching);
    const hasMore = useSelector(gifHasMore);
    const failed = useSelector(gifApiError);
    const onScroll = useCallback((_, distanceToBottom)=>{
        if (!fetching && !failed && hasMore && distanceToBottom < FETCH_TRIGGER_DISTANCE) {
            dispatch(fetchGifs(searchTag, page));
        }
    }, [
        dispatch,
        searchTag,
        page,
        fetching,
        failed,
        hasMore
    ]);
    const onClick = useCallback((gif)=>{
        onSelect({
            originalUrl: gif.images.original.url,
            originalMp4: gif.images.original.mp4,
            stillUrl: gif.images.original_still.url,
            downsizedUrl: gif.images.downsized.url,
            downsizedStillUrl: gif.images.downsized_still.url,
            downsizedSmallMp4: gif.images.downsized_small.mp4,
            height: parseInt(gif.images.original.height),
            width: parseInt(gif.images.original.width)
        });
        onClose();
    }, [
        onSelect,
        onClose
    ]);
    useEffect(()=>{
        dispatch(fetchGifs(searchTag, 0));
    }, [
        dispatch,
        searchTag
    ]);
    const input = /*#__PURE__*/ React.createRef();
    return /*#__PURE__*/ React.createElement(DSModal, {
        useFixedMobileHeight: true,
        isOpen: true,
        hasCloseButton: true,
        onRequestClose: onClose,
        heading: t('ext.gif.search.title'),
        preamble: /*#__PURE__*/ React.createElement(TextInput, {
            ref: input,
            id: "giphyUploadModalInput",
            label: "",
            placeholder: t('ext.gif.search.placeholder'),
            onChange: onChange,
            value: searchTag,
            "data-hook": "giphyUploadModalInput",
            autoFocus: true
        }),
        footerRight: [
            /*#__PURE__*/ React.createElement(PoweredByGiphy, {
                key: "powered-by-giphy"
            })
        ]
    }, /*#__PURE__*/ React.createElement("div", {
        className: s['infinite_scroll_container']
    }, !(gifs || []).length && searchTag ? /*#__PURE__*/ React.createElement("div", {
        className: s['empty_state']
    }, /*#__PURE__*/ React.createElement("div", {
        className: s['empty_title']
    }, t('ext.gif.search.noResults.title')), /*#__PURE__*/ React.createElement("div", {
        className: s['empty_subtitle']
    }, t('ext.gif.search.noResults.text'))) : /*#__PURE__*/ React.createElement(ScrollableContent, {
        onScrolled: onScroll,
        className: s['infinite_scroll']
    }, (gifs || []).map((gif, i)=>{
        return /*#__PURE__*/ React.createElement("div", {
            key: i,
            role: "button",
            tabIndex: 0,
            className: s['gif_img_container'],
            onClick: ()=>onClick(gif)
        }, /*#__PURE__*/ React.createElement("img", {
            loading: "lazy",
            className: s['gif_img'],
            src: gif.images.fixed_width_downsampled.url,
            alt: 'gif'
        }));
    }), fetching && /*#__PURE__*/ React.createElement(LoadingIndicator, {
        view: "llama"
    }))), failed && !(gifs || []).length ? /*#__PURE__*/ React.createElement("div", {
        className: s['error_msg']
    }, " ", t('ext.gif.search.error')) : null);
};
GiphyModal.displayName = 'GiphyModal';
export default GiphyModal;

//# sourceMappingURL=GiphyPopup.js.map